import { render, staticRenderFns } from "./SettingGeneral.vue?vue&type=template&id=0b4dc2c4&"
import script from "./SettingGeneral.vue?vue&type=script&lang=js&"
export * from "./SettingGeneral.vue?vue&type=script&lang=js&"
import style0 from "./SettingGeneral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports